<template>
  <div class="grid">
    <div class="grid-title">
      <div class="row">
        <div class="col-md-8">
          <h4 class="text-bold mt-10">Selected Fabric Inventory Info</h4>
        </div>
        <div class="col-md-4 mb-9">
          <v-select
            :options="fabrics"
            v-model="selectedFabricId"
            label="production_name"
            :reduce="(allFabrics) => allFabrics.id"
            @input="paramChanged"
            placeholder="Choose One"
          />
        </div>
      </div>
    </div>
    <div class="grid-body">
      <div class="row flex">
        <div class="col-md-3">
          <div class="grid bg-primary">
            <div class="grid-body">
              <h5 class="text-white text-bold">Free Stock</h5>
              <h2 class="text-white text-bold">
                {{ ezy.comma(fabric.free_stock) }} Meter
              </h2>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="grid bg-warning">
            <div class="grid-body">
              <h5 class="text-white text-bold">Reserved Stock</h5>
              <h2 class="text-white text-bold">
                {{ ezy.comma(fabric.reserved_stock) }}%
              </h2>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="grid bg-success">
            <div class="grid-body">
              <h5 class="text-white text-bold">Average Sale</h5>
              <h2 class="text-white text-bold">
                {{ ezy.comma(fabric.average_sale) }} Meter
              </h2>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="grid bg-danger">
            <div class="grid-body">
              <h5 class="text-white text-bold">Expected Run Out Date</h5>
              <h2 class="text-white text-bold">
                {{ ezy.date(fabric.oos_date) }}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-20">
        <!-- Bar Chart -->
        <div class="col-md-12 spacing-bottom-sm spacing-bottom">
          <div class="grid white added-margin shadow">
            <div class="grid-body p-20">
              <div class="row">
                <div class="col-md-6 p-14 text-left">
                  Calculate Base On Last <br />
                  <div class="row">
                    <div class="col-md-6">
                      <p-radio
                        class="p-default"
                        :value="12"
                        name="timePeriod2"
                        @change="paramChanged()"
                        v-model="serverParams.inventory.lastXMonths"
                        color="danger"
                      >
                        1 Year
                      </p-radio>
                    </div>
                    <div class="col-md-6">
                      <p-radio
                        class="p-default"
                        :value="6"
                        name="timePeriod2"
                        @change="paramChanged()"
                        v-model="serverParams.inventory.lastXMonths"
                        color="danger"
                      >
                        6 Months
                      </p-radio>
                    </div>
                    <div class="col-md-6">
                      <p-radio
                        class="p-default"
                        :value="3"
                        name="timePeriod2"
                        @change="paramChanged()"
                        v-model="serverParams.inventory.lastXMonths"
                        color="danger"
                      >
                        3 Months
                      </p-radio>
                    </div>
                    <div class="col-md-6">
                      <p-radio
                        class="p-default"
                        :value="1"
                        name="timePeriod2"
                        @change="paramChanged()"
                        v-model="serverParams.inventory.lastXMonths"
                        color="danger"
                      >
                        1 Months
                      </p-radio>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 text-right">
                  <h4 class="text-bold">Fabric Sales in Meters per week</h4>
                </div>
              </div>
            </div>
            <div class="grid-body">
              <div class="text-center chart-container">
                <canvas id="chart"></canvas>
              </div>
            </div>
          </div>
        </div>
        <!-- Bar Chart -->
      </div>
    </div>
  </div>
</template>

<script>
import chart from "@/pages/Tools/Chart";
import { months } from "moment";
export default {
  props: ["pageData", "serverParams", "fabrics"],
  data() {
    return {
      selectedFabricId: null,
      timePeriod: 3,
      fabric: {},
    };
  },
  methods: {
    paramChanged() {
      this.serverParams.inventory.fabricId = this.selectedFabricId;
      this.$emit("changed", 1);
    },
  },
  watch: {
    "pageData.fabricInventoryWithSaleGraph": function () {
      this.fabric = this.pageData.fabricInventoryWithSaleGraph;
      this.selectedFabricId = this.fabric.id;
      chart.create(
        this.fabric.graph.labels,
        this.fabric.graph.total_sales,
        100,
        {
          legend: { display: 0 },
          scales: {
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "Weeks",
                },
              },
            ],
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "Meter",
                },
              },
            ],
          },
        }
      );
    },
  },
};
</script>
